import React, { useState } from 'react';
import '../css/login.css'

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    // Dummy API URL (You can replace this with a real API)
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/login`;

    const payload = {
      username: username,
      password: password,
      is_patient: false
    };

    try {
      // Dummy API Call
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        // throw new Error('Invalid credentials');
        alert('Invalid credentials')
      }

      // Handle successful login
      const data = await response.json();
      console.log('Login Success:', data);
      if (data?.token) {
        localStorage.setItem('token', data.token);
        window.location.href = '/dashboard';
      }
      // Redirect or show success message here
      // Example: window.location.href = '/dashboard'; // Or update state for successful login

    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img style={{ width: '50%' }} src={`${process.env.PUBLIC_URL}/pred_logo.png`} alt="Logo" className="logo" />
        {/* <div className='pred-head'>PRED</div> */}
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div> 
          <button type="submit" className="login-btn">Login</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
